import React, { useMemo, useRef } from "react";
import Producto from "./Producto";
import { bestSellerIds } from "../config/homeConfig";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "../bestSellersLanding.css";

function HomeBestSellers({ products = [], title = "Los más vendidos" }) {

  const carouselRef = useRef(null);

  const bestSellers = useMemo(() => {
    if (!products.length) return [];

    return bestSellerIds
      .map(id => products.find(p => p.id === id))
      .filter(Boolean);
  }, [products]);

  if (!bestSellers.length) return null;

  const scroll = (direction) => {
    const container = carouselRef.current;
    if (!container) return;

    const scrollAmount = 320; // ancho card + gap aprox

    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <section className="best-sellers-section">

      <div className="best-sellers-header">
        <h2 className="best-sellers-title">{title}</h2>
        <p className="best-sellers-subtitle">
          Elegidos por atletas competitivos en todo el país.
        </p>
      </div>

      <div className="carousel-wrapper">

        {/* Flecha izquierda */}
        <button 
          className="carousel-arrow left"
          onClick={() => scroll("left")}
        >
          <FiChevronLeft />
        </button>

        {/* Carrusel */}
        <div 
          className="best-sellers-carousel"
          ref={carouselRef}
        >
          {bestSellers.map((p) => {
            const firstVariant = p.variants?.[0];
            const image =
              firstVariant?.images?.[0] ||
              firstVariant?.image ||
              p.images?.[0] ||
              p.image;
            const price = firstVariant?.price || p.price;

            return (
              <div className="best-sellers-slide" key={p.id}>
                <Producto
                  image={image}
                  name={p.name}
                  price={price}
                  oldPrice={firstVariant?.oldPrice || p.oldPrice}
                  rating={p.rating}
                  slug={p.slug}
                  variants={p.variants}
                />
              </div>
            );
          })}
        </div>

        {/* Flecha derecha */}
        <button 
          className="carousel-arrow right"
          onClick={() => scroll("right")}
        >
          <FiChevronRight />
        </button>

      </div>

    </section>
  );
}

export default HomeBestSellers;
